import React from 'react';
import { Outlet } from 'react-router-dom';

function AccommodationBlocking() {
  return <Outlet />;
}

export default AccommodationBlocking;
